const _ = require('underscore')

function sortDocsWithIndex (docs, sortIndex) {
  const idx = (id) => { const i = sortIndex.indexOf(id); return i >= 0 ? i : Infinity }
  return _.sortBy(docs, (doc) => idx(doc.id))
}

function slimProducts (products=[], allProductAttributes) {
  if (allProductAttributes) {return products}
  let allowed = ['id', 'name', 'price', 'code', 'description', 'modgroups', 'photo', 'sub', 'tags']
  return products.map(product => _.pick(product, allowed))
}

function makeStore (qs, { showDraft=false, allProductAttributes=false }) {
  let docs = qs.docs
  // console.log('make store!')
  if (!showDraft) {
    // console.log('remove draft')
    docs = docs.filter((doc) => !doc.get('draft'))
  }

  let documentTypes =
    _.chain(docs)
     .map((doc) => Object.assign({}, doc.data(), {id: doc.id})) // add id to docs
     .groupBy((doc) => doc.type).value()

  let {product: products=[], subMenu: subMenus=[], shop: shops=[]} = documentTypes

  if (!allProductAttributes) {
    // add submenu name
    const subMenusIndex = _.indexBy(subMenus, 'id')
    products.forEach((product) => {
      let subMenuName = (subMenusIndex[product.subMenuId] && subMenusIndex[product.subMenuId].name && subMenusIndex[product.subMenuId].name.en) || '-'
      let subMenuTags = (subMenusIndex[product.subMenuId] && subMenusIndex[product.subMenuId].tag) || ''
      product.sub = subMenuName
      product.tags = (product.tags || '') + " " + subMenuTags
    })
  }

  let productsGroupedBySubMenuId = _.groupBy(products, p => p.subMenuId)

  if (!shops || !shops[0]) { throw new Error('no shop document') }

  let nested = Object.assign(shops[0], {
    subMenus: sortDocsWithIndex(subMenus, shops[0]['subMenusOrderIndex']).map((subMenu) => {
      return Object.assign(subMenu, {
        products: slimProducts(
          sortDocsWithIndex(productsGroupedBySubMenuId[subMenu.id], subMenu['orderIndex']),
          allProductAttributes
        )
      })
    })
  })

  return {menu: nested}

}
module.exports = makeStore
